<template>
  <div class="YearPicker" @click="expand" :style="style">
    <div :class="{ year: true, expanded }">
      <div
        :class="{
          current: true,
          expanded,
          'year-highlight': $store.state.ui.mode === 'year-highlight',
          disabled: $route.name === 'narrative'
        }"
      >
        <div>{{ year }}</div>
      </div>
      <div class="all-years" v-if="expanded">
        <div
          v-for="y in years"
          :key="y"
          :class="{ y: true }"
          @click="$emit('setYear', y)"
        >
          <div>{{ y }}</div>
        </div>
      </div>
      <div v-if="!first" class="remove" @click="$emit('removeYear')">
        <img :src="removeImagePath" />
      </div>
    </div>
  </div>
</template>

<script>
import { getAssetPath } from "@/constants/constants";

export default {
  name: "YearPicker",
  props: {
    index: Number,
    year: String,
    first: Boolean,
    years: Array
  },
  data() {
    return {
      expanded: false
    };
  },
  computed: {
    removeImagePath() {
      return getAssetPath("/assets/remove.svg");
    },

    style() {
      if (this.index === 0) {
        return {};
      }
      return { zIndex: 50 - this.index };
    }
  },
  methods: {
    expand() {
      if (this.$route.name === "narrative") return;
      this.expanded = !this.expanded;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/constants/_variables.scss";

.YearPicker {
  position: absolute;
  top: $edge-spacing;
  left: $edge-spacing;
  pointer-events: all;
}

.current {
  background-color: $very-light-pink;
  position: absolute;
  font-size: 18px;
  cursor: pointer;
  z-index: 50;
  width: 66px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0px;
  left: 0px;
  position: relative;
  color: black;

  &:hover {
    background-color: $light-gold;
    color: $copper;
  }

  &.year-highlight {
    background-color: $light-gold;
    color: $copper;
  }

  &.disabled {
    cursor: default;
  }

  &.expanded {
    background-color: $copper;
    color: white;
    font-weight: 600;
    box-shadow: $light-shadow;
  }
}

.active {
  font-weight: 600;
}

.all-years {
  position: absolute;
  left: 0px;
  top: 31px;
  z-index: 60;
  color: black;

  .y {
    width: 66px;
    height: 30px;
    background-color: $very-light-pink;
    font-size: 18px;
    margin-top: 2px;
    margin-bottom: 2px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: $light-shadow;

    &:hover {
      background-color: $light-gold;
    }
  }
}

.year {
  display: flex;
}

.remove {
  display: none;
  cursor: pointer;
  margin-left: 5px;
  margin-top: 0.25rem;

  img {
    box-shadow: $light-shadow;
    border-radius: 10px;
    height: 20px;
  }
}

.YearPicker:hover,
.year.expanded {
  .remove {
    display: block;
  }
}
</style>
